/* ============================================
   CUSTOM PRODUCT GALLERY JS
   Vanilla JS, no jQuery dependency
   ============================================ */
(function() {
  'use strict';

  var gallery = document.querySelector('.pg-gallery');
  if (!gallery) return;

  var slides     = gallery.querySelector('.pg-slides');
  var slideEls   = gallery.querySelectorAll('.pg-slide');
  var thumbs     = gallery.querySelectorAll('.pg-thumb');
  var dots       = gallery.querySelectorAll('.pg-dot');
  var prevBtn    = gallery.querySelector('.pg-nav--prev');
  var nextBtn    = gallery.querySelector('.pg-nav--next');
  var zoomResult = document.getElementById('PgZoomResult');
  var current    = 0;
  var total      = slideEls.length;

  function isMobile() { return window.innerWidth < 768; }

  /* --- Go to slide --- */
  function goTo(index, smooth) {
    if (index < 0) index = 0;
    if (index >= total) index = total - 1;
    current = index;
    var slide = slideEls[index];
    slides.scrollTo({
      left: slide.offsetLeft,
      behavior: smooth !== false ? 'smooth' : 'auto'
    });
    updateActive();
  }

  function updateActive() {
    thumbs.forEach(function(t, i) {
      t.classList.toggle('is-active', i === current);
    });
    dots.forEach(function(d, i) {
      d.classList.toggle('is-active', i === current);
    });
    if (thumbs[current]) {
      thumbs[current].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    updateHeight();
  }

  /* --- Adaptive height (mobile) - DISABLED, using CSS aspect-ratio instead --- */
  function updateHeight() {
    /* no-op: fixed aspect-ratio via CSS prevents scroll-snap conflicts */
  }

  /* --- Thumbnail clicks --- */
  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(i);
    });
  });

  /* --- Dot clicks --- */
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  /* --- Arrows --- */
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  /* --- Scroll-snap detection (mobile swipe) --- */
  var scrollTimer;
  slides.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      var scrollLeft = slides.scrollLeft;
      var slideWidth = slides.offsetWidth;
      var newIndex = Math.round(scrollLeft / slideWidth);
      if (newIndex !== current && newIndex >= 0 && newIndex < total) {
        current = newIndex;
        updateActive();
      }
    }, 16);
  }, { passive: true });

  /* scrollend fires exactly when snap settles: instant height update */
  slides.addEventListener('scrollend', function() {
    var scrollLeft = slides.scrollLeft;
    var slideWidth = slides.offsetWidth;
    var newIndex = Math.round(scrollLeft / slideWidth);
    if (newIndex !== current && newIndex >= 0 && newIndex < total) {
      current = newIndex;
      updateActive();
    }
  }, { passive: true });

  /* --- Desktop hover zoom --- */
  if (zoomResult) {
    var PG_ZOOM = 2.5; /* magnification relative to the on-screen image size */
    var zoomScale = 1;
    var zoomImg = new Image();
    var zoomReady = false;
    var activeSlide = null;

    function showZoom(slide) {
      var src = slide.getAttribute('data-zoom-src');
      if (!src) return;
      activeSlide = slide;
      zoomReady = false;
      zoomImg = new Image();
      zoomImg.onload = function() {
        if (activeSlide !== slide) return;
        zoomReady = true;
        /* Magnification relative to the on-screen image, uniform for every product
           regardless of the source photo resolution. Aspect ratio comes from the file. */
        var imgEl = slide.querySelector('img');
        var r = imgEl ? imgEl.getBoundingClientRect() : null;
        zoomScale = (r && r.width && zoomImg.naturalWidth) ? (r.width * PG_ZOOM) / zoomImg.naturalWidth : 1;
        zoomResult.style.backgroundImage = 'url(' + src + ')';
        zoomResult.style.backgroundSize = (zoomImg.naturalWidth * zoomScale) + 'px ' + (zoomImg.naturalHeight * zoomScale) + 'px';
        zoomResult.classList.add('is-visible');
      };
      zoomImg.src = src;
    }

    function hideZoom() {
      zoomResult.classList.remove('is-visible');
      activeSlide = null;
      zoomReady = false;
    }

    function moveZoom(e) {
      if (!zoomReady || !activeSlide) return;
      var img = activeSlide.querySelector('img');
      if (!img) return;
      var rect = img.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      var px = Math.max(0, Math.min(1, x / rect.width));
      var py = Math.max(0, Math.min(1, y / rect.height));

      var rw = zoomResult.offsetWidth;
      var rh = zoomResult.offsetHeight;
      var bgW = zoomImg.naturalWidth * zoomScale;
      var bgH = zoomImg.naturalHeight * zoomScale;

      var bgX = -(px * bgW - rw / 2);
      var bgY = -(py * bgH - rh / 2);
      bgX = Math.min(0, Math.max(bgX, rw - bgW));
      bgY = Math.min(0, Math.max(bgY, rh - bgH));

      zoomResult.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    }

    slideEls.forEach(function(slide) {
      if (slide.getAttribute('data-media-type') !== 'image') return;
      slide.addEventListener('mouseenter', function() {
        if (!isMobile()) showZoom(slide);
      });
      slide.addEventListener('mousemove', function(e) {
        if (!isMobile()) moveZoom(e);
      });
      slide.addEventListener('mouseleave', function() {
        hideZoom();
      });
    });
  }

  /* --- Variant image switching --- */
  window.pgGalleryGoToImage = function(imageId, imageSrc) {
    // Try matching by data-image-id first
    for (var i = 0; i < slideEls.length; i++) {
      if (slideEls[i].getAttribute('data-image-id') == imageId) {
        goTo(i);
        return;
      }
    }
    // Fallback: match by image src substring
    if (imageSrc) {
      var filename = imageSrc.split('?')[0].split('/').pop();
      for (var j = 0; j < slideEls.length; j++) {
        var img = slideEls[j].querySelector('img');
        if (img && img.src && img.src.indexOf(filename) !== -1) {
          goTo(j);
          return;
        }
      }
    }
  };

  /* --- Resize --- */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      goTo(current, false);
      updateHeight();
    }, 150);
  });

  updateActive();

  // Set initial height after first image loads
  var firstImg = slideEls[0] && slideEls[0].querySelector('img');
  if (firstImg) {
    if (firstImg.complete) {
      updateHeight();
    } else {
      firstImg.addEventListener('load', updateHeight, { once: true });
    }
  }

  /* --- Video poster click-to-play --- */
  gallery.querySelectorAll('.pg-video-poster').forEach(function(poster) {
    poster.addEventListener('click', function() {
      poster.classList.add('is-hidden');
      var wrap = poster.closest('.pg-video-wrap');
      var video = wrap && wrap.querySelector('video');
      var iframe = wrap && wrap.querySelector('iframe');
      if (video) {
        video.play();
      } else if (iframe) {
        var src = iframe.getAttribute('src') || '';
        if (src.indexOf('autoplay') === -1) {
          iframe.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
        }
      }
    });
  });
})();
